import { getShipDefinition, type GalaxyPosition, type PlanetShips, type PlayerRace, type ShipId } from '@kaeliux/shared';

/**
 * Small display helpers shared by `FleetsPage` (active fleets), the flight-
 * log/battle-report/espionage sections, and their detail views — factored
 * out so none of them re-derive the same formatting.
 */

export function formatClock(date: Date): string {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

/** Compact date+time — flight logs can be up to 30 days old, so a bare clock time would be ambiguous. */
export function formatDateTime(date: Date): string {
    return date.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatCoords(pos: GalaxyPosition): string {
    return `${pos.galaxy}:${pos.system}:${pos.position}`;
}

export function shipSummary(ships: PlanetShips, race: PlayerRace): string {
    const parts = (Object.entries(ships) as [string, number][])
        .filter(([, count]) => count > 0)
        .map(([key, count]) => `${count}× ${getShipDefinition(race, Number(key) as ShipId).name}`);
    return parts.length > 0 ? parts.join(', ') : 'No ships';
}
